// @/constants/index.ts
export const MATKLUBBEN = "Matklubben";
export const FÖRETAGSKORT  = "Företagskort";
export const KUNDKORT  = "Kundkort";

